import { render, staticRenderFns } from "./sendInvoice.vue?vue&type=template&id=645fce73&scoped=true&"
import script from "./sendInvoice.vue?vue&type=script&lang=js&"
export * from "./sendInvoice.vue?vue&type=script&lang=js&"
import style0 from "./sendInvoice.vue?vue&type=style&index=0&id=645fce73&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645fce73",
  null
  
)

export default component.exports